import { css } from 'emotion'

export const textAlignRight = css`
  text-align: right;
`
